export default __webpack_public_path__ + "static/media/humidity.674503b1.svg";